module.exports = __webpack_public_path__ + "static/media/success.286decb8.mp3";